
import { EditedParticipation } from "../../../Partner/EditedPartner";
import { Filter } from "../../ParticipationFunctions/Filtering";
import { CellWithValidator, StickyNumericHeader } from "../../../../components/Table/TableStyles";
import { offsetOneRow, offsetTwoRows, StateStyledNumberCell } from "../../Styles/ParticipationTableStyles";
import { ValidatedIcon, ValidateFilter, ValidateFilterValue } from "../../../../components/Controls/ValidateControl";
import { NumericFilter } from "../../../../components/Form/FormStyles";

export function ProjectTTFTreesHeader() {
	return (
		<StickyNumericHeader
			style={{ ...offsetOneRow, width: '120px', minWidth: '120px', maxWidth: '120px' }}>
			TTF trees
		</StickyNumericHeader>
	)
}

export function ProjectTTFTreesFilter({ filter, updateFilter }: { filter: Filter, updateFilter: (filter: Filter) => void }) {
	return (
		<StickyNumericHeader style={{ ...offsetTwoRows }}>
			<CellWithValidator>
				<ValidateFilter
					value={filter?.ProjectTTFTreesValidated ?? ValidateFilterValue.Unset}
					onChange={(e) =>
						updateFilter({ ...filter, ProjectTTFTreesValidated: e.value })
					}
				/>
				<NumericFilter
					value={filter?.ProjectTTFTrees ?? ''}
					onChange={(e) =>
						updateFilter({ ...filter, ProjectTTFTrees: e.target.value })
					}
				/>
			</CellWithValidator>
		</StickyNumericHeader>
	)
}

export function ProjectTTFTreesContent({ ppn }: { ppn: EditedParticipation }) {
	return (
		<StateStyledNumberCell
			editStatus={ppn.EditStatus}
			modified={ppn.PlantingProjectId.modified}>
			<CellWithValidator>
				<span>{ppn.PlantingProject.TTFTreesValidated && <ValidatedIcon />}</span>
				<span>{ppn.PlantingProject.TTFTrees?.toLocaleString()}</span>
			</CellWithValidator>
		</StateStyledNumberCell>
	)
}